import React, { useCallback, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type NavSectionProps = {
  id: string;
  setAsSelectedSection: () => void;
  children: React.ReactNode;
};

const NavSection = ({ id, setAsSelectedSection, children }: NavSectionProps): JSX.Element => {
  const history = useHistory();
  const location = useLocation();
  const containerEl = useRef<HTMLDivElement>(null);

  // Update active nav section based off of scroll position
  const handleScroll = useCallback(() => {
    const offsetTop = containerEl.current?.offsetTop;
    if (Math.abs(window.scrollY - offsetTop) < 100 && location?.hash !== `#${id}`) {
      setAsSelectedSection();
      history.push({
        pathname: location?.pathname,
        search: location?.search,
        hash: `#${id}`
      });
    } else if (window.scrollY < 700 && location?.hash !== '') {
      history.push({
        pathname: location?.pathname,
        search: location?.search
      });
    }
  }, [id, location, history, setAsSelectedSection]);

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  });

  return (
    <div id={id} ref={containerEl}>
      {children}
    </div>
  );
};

export { NavSection as default, NavSectionProps };
